export default __webpack_public_path__ + "static/media/img_apache-colorBkg.e0a72a90.png";